import { useQuery } from 'react-query';

import { getCacheSettings } from 'common/helpers';
//consts
import { QUERY_KEYS } from 'consts/queryKeys';
import { getAllProperties, getAllUnits, getUnitOccupancy } from 'modules/_common/api';
import { getOccupancyPartners } from 'modules/accommodations/features/reservations';

export const useQueryOccupancySidebar = ({
  occupancyId,
  isEditingHoldEvent,
  propertyId,
  enabled = true,
}: {
  occupancyId: string | null;
  isEditingHoldEvent: boolean;
  propertyId: string | null;
  enabled?: boolean;
}) => {
  //getAllProperties
  const {
    data: propertyOptions,
    isError: errRentals,
    isLoading: rentalsLoader,
  } = useQuery(QUERY_KEYS.RENTALS_ALL_PROPERTIES, () => getAllProperties(), {
    enabled: !!isEditingHoldEvent && enabled,
    cacheTime: 0,
  });
  //getAllUnits
  const {
    data: unitOptions,
    isError: errUnitOptions,
    isLoading: isLoadingUnitOptions,
  } = useQuery(
    [QUERY_KEYS.RENTALS_ALL_UNITS, propertyId],
    () => getAllUnits(propertyId as string),
    {
      enabled: !!propertyId && enabled,
      cacheTime: 0,
    },
  );
  //getOccupancyData
  const {
    data: occupancyData,
    isError: errOccupancyData,
    isLoading: loaderOccupancyData,
  } = useQuery(
    [QUERY_KEYS.UNITS_UNIT_OCCUPANCY, occupancyId],
    () => getUnitOccupancy(occupancyId as string),
    {
      enabled: !!isEditingHoldEvent && enabled && !!occupancyId,
      cacheTime: 0,
    },
  );
  //getOccupancyPartners
  const {
    data: occupancyPartnersOptions,
    isError: errOccupancyPartners,
    isLoading: occupancyPartnersLoading,
  } = useQuery(QUERY_KEYS.UNITS_OCCUPANCY_PARTNERS, () => getOccupancyPartners(), {
    enabled: enabled,
  });

  const isLoading = loaderOccupancyData || occupancyPartnersLoading || isLoadingUnitOptions;

  return {
    isLoading,
    rentalsLoader,
    isError: errRentals || errOccupancyData || errOccupancyPartners,
    propertyOptions: propertyOptions?.data || null,
    occupancyPartnersOptions: occupancyPartnersOptions || null,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    unitOptions: unitOptions?.data || unitOptions || null,
    errUnitOptions,
    isLoadingUnitOptions,
    occupancyData: occupancyData?.data || null,
  };
};
